import { Service } from "../../../models/ServiceModel";
import {
  getMinServiceDateYmd,
  isServiceDateTimeInPast,
} from "../../../utils/serviceScheduleValidation";
import { isAdicionalEnabledForCompany } from "../../../config/adicionalCompany";

export type StepVisualState = "pending" | "active" | "completed" | "error";

export const WIZARD_STEPS = [
  { id: 1, label: "Información básica", shortLabel: "Paso 1" },
  { id: 2, label: "Rutas y pasajeros", shortLabel: "Paso 2" },
  { id: 3, label: "Asignación de recursos", shortLabel: "Paso 3" },
] as const;

export function isStep1Valid(form: Service, companyName?: string | null): boolean {
  const date = String(form.service_date ?? "").trim();
  const baseValid = Boolean(
    form.company &&
      form.service_time &&
      date >= getMinServiceDateYmd() &&
      !isServiceDateTimeInPast(form.service_date, form.service_time)
  );

  if (!baseValid) return false;

  if (!isAdicionalEnabledForCompany(companyName)) return true;

  return Boolean(form.el_abra_group) && Boolean(String(form.service_reason_text ?? "").trim());
}

export function isStep2Valid(form: Service): boolean {
  const hasSequences = Boolean(form.sequences && form.sequences.length > 0);
  const type = form.service_type;

  switch (type) {
    case "MANUAL":
      return hasSequences && Boolean(form.origin) && Boolean(form.destination);
    case "ORIGEN_DOMICILIOS":
      return hasSequences && Boolean(form.destination);
    case "DESTINO_DOMICILIOS":
      return hasSequences && Boolean(form.origin);
    default:
      return hasSequences && Boolean(form.origin) && Boolean(form.destination);
  }
}

export function isStep3Valid(): boolean {
  return true;
}

export function isStepValidByNumber(
  step: number,
  form: Service,
  companyName?: string | null
): boolean {
  if (step === 1) return isStep1Valid(form, companyName);
  if (step === 2) return isStep2Valid(form);
  if (step === 3) return isStep3Valid();
  return false;
}

export function getStepVisualState(
  stepNumber: number,
  currentStep: number,
  form: Service,
  hasFieldErrors = false,
  companyName?: string | null
): StepVisualState {
  if (stepNumber > currentStep) return "pending";

  const valid = isStepValidByNumber(stepNumber, form, companyName);

  if (stepNumber < currentStep) {
    return valid ? "completed" : "error";
  }

  if (stepNumber === 3 && hasFieldErrors) return "error";
  return valid ? "active" : "error";
}
